module.exports = __webpack_public_path__ + "static/media/tracking6.57672a36.png";